const VALID_TENANTS = ['bk', 'meli'];
const DEFAULT_TENANT = 'bk';

function isValidTenant(tenant) {
  return !!tenant && VALID_TENANTS.includes(String(tenant).toLowerCase());
}

function buildDomainTenantMap() {
  const map = {};
  const prefix = 'REACT_APP_DOMAIN_TENANT_';

  Object.keys(process.env)
    .filter((k) => k.startsWith(prefix))
    .forEach((key) => {
      const raw = process.env[key];
      if (!raw) return;

      const idx = raw.indexOf(':');
      if (idx === -1) return;

      const domain = raw.slice(0, idx).trim().toLowerCase();
      const tenant = raw
        .slice(idx + 1)
        .trim()
        .toLowerCase();

      if (!domain || !isValidTenant(tenant)) return;

      map[domain] = tenant;
    });

  return map;
}

const DOMAIN_TENANT_MAP = buildDomainTenantMap();

function normalizeHost(hostname) {
  const h = (hostname || '').toLowerCase().trim();
  return h.startsWith('www.') ? h.slice(4) : h;
}

export function resolveTenant() {
  const hostname = normalizeHost(window.location.hostname);
  const stage = (process.env.REACT_APP_STAGE || '').toLowerCase();
  const isDev = stage === 'dev';
  const isStg = stage === 'stg';

  // 1) Dev override (localhost manda)
  if (isDev) {
    const envTenant = (process.env.REACT_APP_CLIENT || DEFAULT_TENANT).toLowerCase();
    if (isValidTenant(envTenant)) return envTenant;
  }

  // 2) Staging query param
  if (isStg) {
    const params = new URLSearchParams(window.location.search);
    const queryTenant = (params.get('tenant') || params.get('client') || '').toLowerCase();
    if (isValidTenant(queryTenant)) return queryTenant;
  }

  // 3) Exact domain map
  const mapped = DOMAIN_TENANT_MAP[hostname];
  if (isValidTenant(mapped)) return mapped;

  // 4) Subdomain fallback (bk.*, meli.*)
  const parts = hostname.split('.');
  if (parts.length > 2) {
    const subdomain = parts[0].toLowerCase();
    if (isValidTenant(subdomain)) return subdomain;
  }

  return DEFAULT_TENANT;
}
